/**
 * The privacy policy and terms of use live on the public site, not in the console.
 *
 * They are public documents with one text: an agency reads them before it has an account, and a
 * second copy here would drift from the one on promanage.nz the first time either was edited. The
 * console's own /privacy and /terms routes exist only to send an old link to these.
 */
export const PRIVACY_URL = 'https://promanage.nz/privacy/';
export const TERMS_URL = 'https://promanage.nz/terms/';
